export default __webpack_public_path__ + "static/media/mascot.d4d91286.png";